const API_HOST_US = process.env.NEXT_PUBLIC_API_HOST || 'https://api-a.ecoflow.com/website';
const API_HOST_CN = process.env.NEXT_PUBLIC_API_HOST_CN || 'https://api-e.ecoflow.com/website';
const API_HOST_EU = process.env.NEXT_PUBLIC_API_HOST_EU || 'https://api-cn.ecoflow.com/website';
const data_center_eu = ['de', 'it', 'uk', 'fr', 'cis', 'es', 'eu', 'za', 'sa', 'jp', 'kr', 'nl']; //欧州数据中心
const data_center_cn = ['cn']; //国区数据中心
export const getBaseUrl = (locale = 'us') => {
    if (data_center_eu.includes(locale)) {
        return API_HOST_EU;
    } else if (data_center_cn.includes(locale)) {
        return API_HOST_CN;
    }
    return API_HOST_US;
};
